export default "__VITE_ASSET__CGugWOK0__"